import { SearchCategory } from '../GlobalSearchTabs';
import {
  BaseSearchProps,
  ExtendedDocCompareChunkFinderChunk,
  Widget,
} from '../types';
import { searchDocuments } from './documentSearch';
import { searchFunds } from './fundSearch';
import { searchPortfolios } from './portfolioSearch';
import { searchWidgets } from './widgetSearch';

interface SearchCallbacks {
  onFundsSuccess: (results: ExtendedDocCompareChunkFinderChunk[]) => void;
  onPortfoliosSuccess: (results: ExtendedDocCompareChunkFinderChunk[]) => void;
  onDocumentsSuccess: (results: ExtendedDocCompareChunkFinderChunk[]) => void;
  onWidgetsSuccess: (results: Widget[]) => void;
  onError: (error: Error) => void;
}

export const executeSearch = async (
  searchTerm: string,
  activeCategory: SearchCategory,
  callbacks: SearchCallbacks,
  widgetsOnly: boolean = false,
): Promise<void> => {
  try {
    if (widgetsOnly) {
      // Only search widgets
      await searchWidgets({
        searchTerm,
        onSuccess: callbacks.onWidgetsSuccess,
        onError: callbacks.onError,
        onEmpty: () => callbacks.onWidgetsSuccess([]),
      } as BaseSearchProps<Widget>);
      return;
    }

    // Run all searches in parallel
    await Promise.all([
      // Search funds
      searchFunds({
        searchTerm,
        onSuccess: callbacks.onFundsSuccess,
        onError: callbacks.onError,
        onEmpty: () => callbacks.onFundsSuccess([]),
      } as BaseSearchProps<ExtendedDocCompareChunkFinderChunk>),

      // Search portfolios
      searchPortfolios({
        searchTerm,
        onSuccess: callbacks.onPortfoliosSuccess,
        onError: callbacks.onError,
        onEmpty: () => callbacks.onPortfoliosSuccess([]),
      } as BaseSearchProps<ExtendedDocCompareChunkFinderChunk>),

      // Search documents
      searchDocuments({
        searchTerm,
        onSuccess: callbacks.onDocumentsSuccess,
        onError: callbacks.onError,
        onEmpty: () => callbacks.onDocumentsSuccess([]),
      } as BaseSearchProps<ExtendedDocCompareChunkFinderChunk>),

      // Search widgets
      searchWidgets({
        searchTerm,
        onSuccess: callbacks.onWidgetsSuccess,
        onError: callbacks.onError,
        onEmpty: () => callbacks.onWidgetsSuccess([]),
      } as BaseSearchProps<Widget>),
    ]);
  } catch (error) {
    callbacks.onError(error as Error);
  }
};
